import { Message, MultiSelect } from './../models/messages.model';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs/Observable";

@Injectable()
export class MessagesService {
    private headers() {
        return new HttpHeaders({
            Authorization: `Bearer ${sessionStorage.getItem('authorizationData')}`
        })
    };

    private baseUrl = '/api';

    constructor(protected httpClient: HttpClient) { }

    public getMessages(): Observable<any> {
        return this.httpClient.get(`${this.baseUrl}/Messages`, { headers: this.headers() })
    }

    public getMessagesList(pageNumber: number, pageSize: number, searchQuery: string = undefined): Observable<any> {
        let searchQueryValue = `&SearchExpression=${searchQuery}`;

        return this.httpClient.get(`${this.baseUrl}/Messages/filter?PageNumber=${pageNumber}&PageSize=${pageSize}${searchQuery ? searchQueryValue : ''}`, { headers: this.headers() })
    }

    public getMessagesBody(messageId: number): Observable<any> {
        return this.httpClient.get(`${this.baseUrl}/Messages/body?messageId=${messageId}`, { headers: this.headers() })
    }

    public getUnreadMessages(): Observable<any> {
        return this.httpClient.get(`${this.baseUrl}/Messages/unreadMessages`, { headers: this.headers() })
    }

    public createMessage(message: Message) {
        return this.httpClient.post(`${this.baseUrl}/Messages`, message, { headers: this.headers() })
    }

    public updateMessageCount(message: Message): Observable<any> {
        return this.httpClient.request('PUT', `${this.baseUrl}/Messages?MessageId=${message.messageId}&Status=${message.messageStatus}`, { headers: { headers: this.headers() }.headers, responseType: 'text' });
    }

    public updateMessageStatus(multiSelectObj: MultiSelect) {
        return this.httpClient.request('POST', `${this.baseUrl}/Messages/statuses`, { headers: this.headers(), responseType: 'text', body: multiSelectObj });
    }

    public softDelete(multiSelect) {
        return this.httpClient.request('POST', `${this.baseUrl}/Messages/softdelete`, { headers: this.headers(), responseType: 'text', body: multiSelect });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/services/messages.service.ts